let paths = new Set().add('clear');
let patches = {};

export default {
  paths,
  patches,
  clear: () => {
    paths.clear();
    Object.keys(patches).forEach((p) => {
      delete patches[p];
    });
  },
};

function addPatch(path, patch) {
  if (patches[path] === undefined) {
    patches[path] = [];
  }
  patches[path].push(patch);
}
export function addChanges(changes) {
  for (let item of changes) {
    if (item.path[0] !== 'hoverCell' && item.path[0] !== 'isDragging') {
      paths.add(item.path[0]);
      addPatch(item.path[0], item);
    }
  }
}
